export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyDmfx8eGFNmVEhLGQ-KC74Bg56N-wZWvUA',
    authDomain: 'odss-mobile.firebaseapp.com',
    databaseURL: 'https://odss-mobile.firebaseio.com',
    projectId: 'odss-mobile',
    storageBucket: 'odss-mobile.appspot.com',
    messagingSenderId: '666985738510',
    appId: '1:666985738510:web:5d39ca3ecb5be83744275f',
    measurementId: 'G-MSQSNBVPBK',
  },
  api: (): string => {
    // 本番カットオーバー: NestJS API Gateway → Hono Workers（カスタムドメイン、ルート直下配信）。
    if (!Object.hasOwn(localStorage, 'apiKey') || localStorage.getItem('apiKey') === 'odss') {
      // return 'https://6w1jcv46t6.execute-api.ap-northeast-1.amazonaws.com/odss/';
      return 'https://api.odss.jp/';
    }

    if (localStorage.getItem('apiKey') === 'futaba') {
      // return 'https://7d5usv9j67.execute-api.ap-northeast-1.amazonaws.com/futaba/';
      return 'https://api.futaba.odss.jp/';
    }

    throw new Error('データベースが適切に選択されていません');
  },
  name: (): string => {
    if (!Object.hasOwn(localStorage, 'apiKey') || localStorage.getItem('apiKey') === 'odss') {
      return '有限会社小田商店';
    }
    if (localStorage.getItem('apiKey') === 'futaba') {
      return 'フタバ水栓株式会社';
    }
    throw new Error('データベースが適切に選択されていません');
  },
  // 本番では e2e バイパスを常に無効化（認証ゲートは本番動作のまま）。
  e2e: false,
};
